import { LoadingSkeleton } from "@homebound/beam";
import { signedCount } from "src/utils";
import {
  ReviewProjectScheduleImpactQueryVariables,
  useReviewProjectScheduleImpactQuery,
} from "../3.ReviewImpactStep.generated";
import { scheduleShift } from "../reviewImpactUtils";

type ScheduleImpactSummaryValueProps = { variables: ReviewProjectScheduleImpactQueryVariables };

/**
 * The Review step's schedule stat. It runs its own query rather than gating the stats: projecting the schedule
 * re-runs the simulator, so every other stat would sit behind a 30s-timeout HTTP call for a number it doesn't need.
 */
export function ScheduleImpactSummaryValue(props: ScheduleImpactSummaryValueProps) {
  const { variables } = props;
  const query = useReviewProjectScheduleImpactQuery({ variables });
  if (query.loading) return <LoadingSkeleton rows={1} columns={1} size="sm" />;
  if (query.error || !query.data) return <>Unavailable</>;
  const shift = scheduleShift(query.data.projectScheduleImpact);
  return <>{shift ? signedCount(shift.count, shift.unit) : "None"}</>;
}
